var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"mention",staticClass:"mention"},[(_vm.size)?_c('NcUserBubble',{key:_vm.isDarkTheme ? 'dark' : 'light',attrs:{"display-name":_vm.name,"avatar-image":_vm.avatarUrl,"user":_vm.id,"size":_vm.size,"primary":_vm.primary}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }